<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="formData" :rules="validatorRules" slot="detail" :colon="false">
          <a-divider class="aDividerBlue" orientation="left">{{ $t('工单信息') }}</a-divider>
          <detail-list :col="3">
            <detail-list-item :term="$t('工单编号')">{{ formData.model.ticketsNum }}</detail-list-item>
            <detail-list-item :term="$t('工单类型')">{{ $t(orderType) }}</detail-list-item>
            <detail-list-item :term="$t('工单联系人')">{{ formData.model.ticketsContact }}</detail-list-item>
          </detail-list>
          <detail-list :col="3">
            <detail-list-item :term="$t('紧急程度')">
              <a-tag :color="getTagColor(formData.model.ticketsEmergency)">
                {{ setJJ(formData.model.ticketsEmergency) }}
              </a-tag>
            </detail-list-item>
            <detail-list-item :term="$t('预约时间')">{{ formData.model.ticketsDeadline }}</detail-list-item>
            <detail-list-item :term="$t('联系电话')">{{ formData.model.ticketsContactPhone }}</detail-list-item>
          </detail-list>
          <detail-list :col="3">
            <detail-list-item :term="$t('备注')" :itemCol="1">
              {{ formData.model.ticketsChangeMeter?.changingMeterReasonDetail }}
            </detail-list-item>
          </detail-list>

          <!-- 系统用户 -->
          <template>
            <a-divider class="aDividerBlue" orientation="left">{{ $t('用户信息') }}</a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('用户编号')">{{
                formData.model.user && formData.model.user.userId
              }}</detail-list-item>
              <detail-list-item :term="$t('用户姓名')">{{ formData.userInfo?.userName }}</detail-list-item>
              <detail-list-item :term="$t('手机号码')">{{ formData.userInfo?.userPhone }}</detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('开户时间')">{{ formData.userInfo?.userCreateTime }}</detail-list-item>
              <detail-list-item :term="$t('用水性质')">{{ formData.userInfo?.wtName }}</detail-list-item>
              <detail-list-item :term="$t('用水状态')">{{
                formData.userInfo.userState == 0 ? $t('未开始计费') : formData.userInfo.userState == 1 ? $t('已开始计费') : ''
              }}</detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('区域信息')" :itemCol="1">{{ formData.userInfo.userAreaName }}</detail-list-item>
              <detail-list-item :term="$t('用户地址')" :itemCol="1">{{ formData.userInfo.userAddr }}</detail-list-item>
              <!-- <detail-list-item term="用户地址" :itemCol="1">{{meterInfo.userAreaName.slice(meterInfo.userAreaName.indexOf('-')+1,meterInfo.userAreaName.length)+'-'+meterInfo.userAddr}}</detail-list-item> -->
            </detail-list>
          </template>
          <!-- 报停 -->
          <template v-if="this.orderType == '报停' || this.orderType == '销户' || this.orderType == '用水性质变革'">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('旧表信息') }}</a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('旧表编号')">{{ formData.oldMeter.meterId }}</detail-list-item>
              <detail-list-item :term="$t('水表厂家')">{{ formData.oldMeter.mtName }}</detail-list-item>
              <detail-list-item :term="$t('口径')"
                >{{ formData.oldMeter.mtCaliber ? 'DN' + formData.oldMeter.mtCaliber : '' }}
              </detail-list-item>
            </detail-list>

            <detail-list :col="3">
              <detail-list-item :term="$t('表计费起始读数(m³)')">{{
                formData.oldMeter && formData.oldMeter.oldMeterStartNum
              }}</detail-list-item>
              <detail-list-item :term="$t('末次上报结算流量(m³)')">{{
                formData.oldMeter && formData.oldMeter.oldUserCalNum
              }}</detail-list-item>
              <detail-list-item :term="$t('末次上报结算余额(元)')">{{
                formData.oldMeter && formData.oldMeter.userAccountNum
              }}</detail-list-item>
            </detail-list>

            <detail-list :col="3">
              <detail-list-item :term="$t('末次上报日期')">{{
                formData.oldMeter && formData.oldMeter.meterUpTime
              }}</detail-list-item>
            </detail-list>
          </template>

          <!-- 报停 拆表  -->
          <template v-if="this.orderType == '报停' || this.orderType == '销户'">
            <a-col :span="24">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('录入处理信息') }}</a-divider>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('旧表机械读数(m³)')" :prop="'oldMeter.meterOldMachineSumFlow'">
                    <a-input-number
                      v-model="formData.oldMeter.meterOldMachineSumFlow"
                      :placeholder="$t('请输入旧表机械读数')"
                      style="width: 100%"
                      :min="0"
                      :precision="2"
                      :disabled="notInput"
                      @change="meterOldMachineSumFlowInput"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item
                    :label="$t('剩余金额(元)')"
                    :rules="meterUserAccountNumAfterChangeRules"
                    :prop="'oldMeter.meterUserAccountNumAfterChange'"
                  >
                    <a-input-number
                      v-model="formData.oldMeter.meterUserAccountNumAfterChange"
                      :suffix="$t('元')"
                      :precision="2"
                      style="width: 100%"
                      :placeholder="$t('请输入剩余金额')"
                      :disabled="formData.oldMeter.whetherSettlementOldTable == 1"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item
                    :label="$t('是否以旧表机械读数结算')"
                    :prop="'oldMeter.whetherSettlementOldTable'"
                    :rules="whetherSettlementOldTableRules"
                  >
                    <a-select
                      v-model="formData.oldMeter.whetherSettlementOldTable"
                      :placeholder="$t('请选择是否以旧表机械读数结算')"
                      :allowClear="true"
                      @change="whetherSettlementOldTableChange"
                    >
                      <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="24" v-if="this.orderType == '销户'">
                <a-col :span="12">
                  <a-form-model-item :label="$t('水表照片')" :prop="'model.resolvedPictureFront'">
                    <j-image-upload
                      v-model="formData.model.resolvedPictureFront"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('现场施工照片')" :prop="'model.resolvedPictureOpposite'">
                    <j-image-upload
                      v-model="formData.model.resolvedPictureOpposite"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="24" v-if="this.orderType == '报停'">
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理照片')" :prop="'model.resolvedPictureOpposite'">
                    <j-image-upload
                      v-model="formData.model.resolvedPictureOpposite"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row v-if="!notInput" :gutter="24">
                <a-col :span="24">
                  <a-form-model-item :label="$t('处理描述')" prop="model.handleUserDescription">
                    <a-textarea
                      v-model="formData.model.handleUserDescription"
                      :disabled="notInput"
                      :placeholder="$t('请输入处理描述')"
                      :rows="4"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row v-if="notInput" :gutter="24">
                <a-col :span="24">
                  <detail-list :col="3">
                    <detail-list-item :term="$t('处理描述')" :itemCol="1">{{
                      formData.model.handleUserDescription && formData.model.handleUserDescription
                    }}</detail-list-item>
                  </detail-list>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item :label="$t('备注')" prop="notInputRemark">
                    <a-textarea v-model="notInputRemark" :placeholder="$t('请输入备注信息')" :rows="4" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </template>
          <!-- 复接 装新表  -->
          <template v-if="this.orderType == '复接'">
            <a-col :span="24" v-if="this.orderType == '复接'">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('新表具信息') }}</a-divider>
              <a-button
                v-if="!notInput"
                type="primary"
                style="margin-bottom: 10px"
                :disabled="notInput"
                icon="plus"
                @click="selectNewMeter"
              >
                {{ $t('选择新表') }}
              </a-button>

              <detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('新表编号')">
                    {{ formData.newMeter.newMeterId }}
                  </detail-list-item>
                  <!-- <detail-list-item term="用水性质">{{oldMeter.wtName}}</detail-list-item> -->
                  <detail-list-item :term="$t('新表厂商')">
                    {{ formData.newMeter.newMtName }}
                  </detail-list-item>
                  <detail-list-item :term="$t('口径')">
                    {{ formData.newMeter.newMtCaliber ? 'DN' + formData.newMeter.newMtCaliber : '' }}
                  </detail-list-item>
                </detail-list>
              </detail-list>

              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('新表开始计费读数(m³)')" prop="newMeter.meterStartNum">
                    <a-input-number
                      v-model="formData.newMeter.meterStartNum"
                      :min="0"
                      :precision="2"
                      style="width: 100%"
                      :placeholder="$t('请输入起始读数')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('是否收费')" :prop="'model.payOrNot'">
                    <a-select
                      v-model="formData.model.payOrNot"
                      :placeholder="$t('请选择是否收费')"
                      :disabled="notInput"
                      @change="payOrNotChange"
                    >
                      <a-select-option :value="1">{{ $t('收费') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('不收费') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row v-if="formData.model.payOrNot == 1" :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('付款码')" prop="paymentCode">
                    <a-upload
                      action=""
                      list-type="picture-card"
                      :file-list="qrcodeImage"
                      @preview="handlePreview"
                      disabled
                    >
                    </a-upload>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('支付凭证')" prop="model.infoPicture">
                    <j-image-upload
                      v-model="formData.model.infoPicture"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                      @change="handleImageChange"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理照片')" :prop="!notInput?'model.resolvedPictureOpposite':''">
                    <j-image-upload
                      v-model="formData.model.resolvedPictureOpposite"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row v-if="!notInput" :gutter="24">
                <a-col :span="24">
                  <a-form-model-item :label="$t('处理描述')" prop="model.handleUserDescription">
                    <a-textarea
                      v-model="formData.model.handleUserDescription"
                      :disabled="notInput"
                      :placeholder="$t('请输入处理描述')"
                      :rows="4"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row v-if="notInput" :gutter="24">
                <a-col :span="24">
                  <detail-list :col="3">
                    <detail-list-item :term="$t('处理描述')" :itemCol="1">{{
                      formData.model.handleUserDescription && formData.model.handleUserDescription
                    }}</detail-list-item>
                  </detail-list>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item :label="$t('备注')" prop="notInputRemark">
                    <a-textarea v-model="notInputRemark" :placeholder="$t('请输入备注信息')" :rows="4" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </template>
          <!-- 用水性质变更 处理 上传图片与详情  -->
          <template v-if="this.orderType == '用水性质变更'">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('稽查核验信息') }}</a-divider>

            <a-row v-if="!notInput" :gutter="24">
              <a-col :span="24">
                <a-form-model-item :label="$t('核验稽查描述')" prop="model.inspectionDetail.inspectionDescription">
                  <a-textarea
                    v-model="formData.model.inspectionDetail.inspectionDescription"
                    :disabled="notInput"
                    :placeholder="$t('请输入处理描述')"
                    :rows="4"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24" v-if="!(notInput && !formData.model.inspectionDetail.inspectionPicture)">
              <a-col :span="8">
                <a-form-model-item :label="$t('核验稽查照片')" prop="model.inspectionDetail.inspectionPicture">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    :disabled="notInput"
                    v-model="formData.model.inspectionDetail.inspectionPicture"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row v-if="notInput" :gutter="24">
              <a-col :span="24">
                <detail-list :col="3">
                  <detail-list-item :term="$t('核验稽查描述')" :itemCol="1">{{
                    formData.model.inspectionDetail && formData.model.inspectionDetail.inspectionDescription
                  }}</detail-list-item>
                </detail-list>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('备注')" prop="notInputRemark">
                  <a-textarea v-model="notInputRemark" :placeholder="$t('请输入备注信息')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </template>
        </a-form-model>
      </j-form-container>
    </a-spin>

    <!-- 选择新表弹窗 -->
    <SelectNewMeterModal
      :visible="selectNewMeterModalVisible"
      @update:visible="val => (selectNewMeterModalVisible = val)"
      @ok="handleMeterSelected"
    />
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel1">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </j-modal>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import DetailList from '@/components/tools/DetailList'
const DetailListItem = DetailList.Item
import JUpload from '@/components/jeecg/JUpload'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import JInput from '@/components/jeecg/JInput'
import { PhoneNumberPattern } from '@/utils/regPattern'
import SelectNewMeterModal from './selectNewMeter.vue'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import {fileUrl} from'@/utils/util'
export default {
  // mixins: [JeecgListMixin],
  name: 'TearDownAndInstallModal',
  components: {
    DetailList,
    DetailListItem,
    JImageUpload,
    JUpload,
    JInput,
    SelectNewMeterModal,
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      notInput: false,
      disableSubmit: false,
      confirmLoading: false,
      orderType: '', // 单据类型 报停、复接
      optionType: '', // 操作类型 处理、审核
      formData: {
        model: {
          ticketsEmergency: undefined,
          ifNeedChangeMeter: undefined,
        }, // 工单信息
        userInfo: {}, // 系统用户信息
        oldMeter: {
          whetherSettlementOldTable: undefined,
        }, // 旧表信息
        newMeter: {}, // 新表信息
      }, // 表单信息
      qrcodeImage: [
        {
          uid: '-1',
          name: '付款码',
          status: 'done',
          url: fileUrl+'/file/payment_code.png',
        }
      ],
      previewVisible: false,
      previewImage: '',
      url: {
        pass: '/jeecg-engineering/flowable/task/completeByDateId',
        reject: '/jeecg-engineering/flowable/task/taskRejectByDataId',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        edit: '/jeecg-engineering/engineering/meterRepair/edit',
        useOldMachineSumFlow: '/jeecg-charge/meter/meteChangeMeterRecord/useOldMachineSumFlow', //是否以旧表读数结算
        newMeterInfo: '/jeecg-charge/meter/meterinfo/list', //新表接口
        list: '/jeecg-charge/meter/meterUserinfo/list',
        queryUserById: '/jeecg-charge/meter/meterUserinfo/queryById',
        userList: '/sys/user/list',
        getMeterUserInfoByKeyId: '/jeecg-charge/meter/meteChangeMeterRecord/getMeterUserInfoByKeyId',
      },
      candidateUsersList: [],
      meterRepair: {},
      fileList: '',
      notInputRemark: '',
      selectNewMeterModalVisible: false,
    }
  },
  watch: {
    'model.audit': {
      handler(val) {
        if (val == 1) {
          this.validatorRules.remark.required = false
        } else {
          this.validatorRules.remark.required = true
        }
      },
    },
    'model.handleUserName': {
      handler(val) {
        if (val) {
          var info = this.candidateUsersList.find(item => item.username == val)
          this.$set(this.formData.model, 'handleUserRealName', info.realname)
          this.$set(this.formData.model, 'handleUserPhone', info.telephone || info.phone)
        }
      },
    },
  },
  computed: {
    validatorRules() {
      return {
        'oldMeter.meterOldMachineSumFlow': [{ required: true, message: this.$t('请输入旧表机械读数'), trigger: 'change' }],
        'model.resolvedPictureFront': [{ required: true, message: this.$t('请上传图片'), trigger: 'change' }],
        'model.resolvedPictureOpposite': [{ required: true, message: this.$t('请上传图片'), trigger: 'change' }],
        'model.handleUserDescription': [{ required: true, message: this.$t('请输入处理描述'), trigger: ['change', 'blur'] }],
        'model.inspectionDescription': [{ required: true, message: this.$t('请输入处理描述'), trigger: ['change', 'blur'] }],
        'model.inspectionDetail.inspectionDescription': [
          { required: true, message: this.$t('请输入稽核查验描述'), trigger: ['change', 'blur'] },
        ],
        'model.infoPicture': [{ required: true, message: this.$t('请上传支付凭证'), trigger: ['change', 'blur'] }],
        'newMeter.meterStartNum': [{ required: true, message: this.$t('请输入新表开始计费读数'), trigger: ['change', 'blur'] }],
        // fixPhone:[{ required: true, message: '请输入修理人员电话' },{pattern: PhoneNumberPattern,message: '请输入正确的手机号码'}],
        // handleUserDescription:{ required: true,message: '请输入处理描述', trigger: 'blur' },
        // fixSolve:{ required: true,message: '请选择是否解决', trigger: 'change' },
        // fixPicture:{ required: true,message: '请选择修理图片', trigger: 'change' },
      }
    },
    whetherSettlementOldTableRules() {
      // 根据 notInput 的值动态设置是否必填
      return this.notInput
        ? [{ required: true, message: this.$t('请选择是否以旧表机械读数结算'), trigger: ['change', 'blur'] }]
        : []
    },
    meterUserAccountNumAfterChangeRules() {
      // 根据 notInput 的值动态设置是否必填
      return this.notInput ? [{ required: true, message: this.$t('请输入剩余金额'), trigger: ['change', 'blur'] }] : []
    },
  },
  methods: {
    setJJ(item) {
      return filterDictTextByCache('ticketsEmergency', item)
    },
    getUserList() {
      this.candidateUsersList = []
      getAction(this.url.userList, { status: 1, pageSize: 999 }).then(res => {
        if (res.success) {
          this.candidateUsersList = res.result.records
        }
      })
    },
    init(row, type) {
      let that = this
      this.optionType = type
      this.visible = true
      that.confirmLoading = false
      // 清空表单验证
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
      this.formData = {
        model: {
          // 表单数据 工单 报停数据
          id: row.id,
          ticketsType: row.ticketsType,
          ticketsId: row.id,
        }, // 工单信息
        userInfo: {}, // 系统用户信息
        oldMeter: {}, // 旧表信息
        newMeter: {}, // 新表信息
      }
      this.notInputRemark = ''
      if (row.ticketsType == 3) {
        this.orderType = '报停'
      } else if (row.ticketsType == 4) {
        this.orderType = '复接'
      } else if (row.ticketsType == 7) {
        this.orderType = '销户'
      } else if (row.ticketsType == 8) {
        this.orderType = '用水性质变更'
      }
      this.title = this.orderType + this.optionType
      if (this.optionType == '审核') {
        this.notInput = true
      } else {
        this.notInput = false
      }
      // this.getUserList();
      // 获取工单数据
      getAction(this.url.queryById, { id: row.id }).then(res => {
        if (res.success) {
          that.formData.model = {
            ...res.result,
            ...that.formData.model,
            handleUserDescription: res.result.ticketsChangeMeter?.remark,
          }
          console.log('工单数据：', this.formData.model)
          // 查询 用户信息
          if (that.formData.model.user && that.formData.model.user.userId) {
            getAction(this.url.list, { userId: that.formData.model.user.userId }).then(res => {
              if (res.success && res.result.records.length > 0) {
                that.formData.userInfo = res.result.records[0] || {}
                console.log('用户数据1', this.formData.userInfo)
                // 用户表 末次数据
                // 查询旧表数据
                that.setOldMeterInfo()
              } else {
                let param = {
                  userId: that.formData.model.user.userId,
                  emptyUserFlag: 1,
                }
                getAction(this.url.list, param).then(res => {
                  if (res.success && res.result.records.length > 0) {
                    that.formData.userInfo = res.result.records[0] || {}
                    console.log('用户数据2-已销户的用户', this.formData.userInfo)
                    // 用户表 末次数据
                    that.setOldMeterInfo()
                  }
                })
              }
            })
          }
          // }else if (that.formData.model.ticketsChangeMeter) {
          //   // 查询 用户信息
          //   if(that.formData.model.ticketsChangeMeter.userId){
          //     getAction(this.url.list, { userId: that.formData.model.ticketsChangeMeter.userId }).then(res => {
          //       if (res.success && res.result.records.length > 0) {
          //         that.formData.userInfo = res.result.records[0] || {}
          //       } else {
          //         getAction(this.url.list, {
          //           userId: that.formData.model.ticketsChangeMeter.userId,
          //           isStop: 1,
          //         }).then(res => {
          //           if (res.success && res.result.records.length > 0) {
          //             that.formData.userInfo = res.result.records[0] || {}
          //           }
          //         })
          //       }
          //     })
          //   }
          // }

          if (that.formData.model.ticketsChangeMeter && that.formData.model.ticketsChangeMeter.newMeterId) {
            // 复接
            // 新表数据
            let params = {
              meterId: that.formData.model.ticketsChangeMeter.newMeterId,
            }
            getAction(this.url.newMeterInfo, params).then(res => {
              if (res.success) {
                let selectedMeter = res.result.records[0]
                that.formData.newMeter = res.result.records[0] || {}
                // 新表编号 新表口径 新表厂商 新表开始计费读数
                this.$set(that.formData.newMeter, 'newMeterId', selectedMeter.meterId)
                this.$set(that.formData.newMeter, 'newMtCaliber', selectedMeter.mtCaliber)
                this.$set(that.formData.newMeter, 'newMtName', selectedMeter.mtName)
                this.$set(that.formData.newMeter, 'meterStartNum', that.formData.model.ticketsChangeMeter.meterStartNum)
              }
            })
          }
          // 是否收费
          if (that.formData.model.infoPicture) {
            this.$set(that.formData.model, 'payOrNot', 1)
          } else {
            this.$set(that.formData.model, 'payOrNot', 0)
          }
        }
      })
    },
    setOldMeterInfo() {
      let that = this
      // 当单据状态》已处理时，取旧值
      if (that.formData.model.ticketsState > 1) {
        console.log('用户表末次数据--取旧值')
        this.setOldMeterSubInfo()
        console.log('用户表末次数据--取旧值oldMeterStartNum', that.formData.oldMeter.oldMeterStartNum)
        console.log('用户表末次数据--取旧值oldUserCalNum', that.formData.oldMeter.oldUserCalNum)
        console.log('用户表末次数据--取旧值userAccountNum', that.formData.oldMeter.userAccountNum)
        console.log('用户表末次数据--取旧值meterUpTime', that.formData.oldMeter.meterUpTime)
        // 查询旧表信息
        getAction(this.url.newMeterInfo, { meterId: that.formData.model.ticketsChangeMeter.oldMeterId }).then(res => {
          if (res.success) {
            that.formData.oldMeter = {
              ...(res.result.records[0] || {}),
              ...that.formData.oldMeter,
            }
            console.log('旧表数据', this.formData.oldMeter)
            this.setOldMeterNum()
          }
        })
      } else {
        console.log('用户表末次数据--取实时')
        // 未处理 时，取实时
        getAction(that.url.getMeterUserInfoByKeyId, {
          userKeyId: that.formData.model.ticketsChangeMeter.userKeyId,
        }).then(res => {
          if (res.success && res.result != null) {
            this.$set(that.formData.oldMeter, 'oldMeterStartNum', that.formData.userInfo.userMeterStartNum)
            this.$set(that.formData.oldMeter, 'oldUserCalNum', res.result.userCalNum)
            this.$set(that.formData.oldMeter, 'userAccountNum', res.result.userAccountNum)
            this.$set(that.formData.oldMeter, 'meterUpTime', res.result.meterUpTime)

            console.log('用户表末次数据--取实时oldMeterStartNum', that.formData.oldMeter.oldMeterStartNum)
            console.log('用户表末次数据--取实时oldUserCalNum', that.formData.oldMeter.oldUserCalNum)
            console.log('用户表末次数据--取实时userAccountNum', that.formData.oldMeter.userAccountNum)
            console.log('用户表末次数据--取实时meterUpTime', that.formData.oldMeter.meterUpTime)
          }
          // 查询旧表信息
          getAction(this.url.newMeterInfo, { meterId: that.formData.model.ticketsChangeMeter.oldMeterId }).then(res => {
            if (res.success) {
              that.formData.oldMeter = {
                ...(res.result.records[0] || {}),
                ...that.formData.oldMeter,
              }
              console.log('旧表数据', this.formData.oldMeter)
              this.setOldMeterNum()
            }
          })
        })
      }
    },
    setOldMeterSubInfo() {
      let that = this
      // 已解决 换表的工单 则取 记录值
      if (that.formData.model.ticketsChangeMeter && that.formData.model.ticketsChangeMeter.oldMeterStartNum !== null) {
        // 表计费起始读数
        this.$set(that.formData.oldMeter, 'oldMeterStartNum', that.formData.model.ticketsChangeMeter.oldMeterStartNum)
      }
      if (that.formData.model.ticketsChangeMeter && that.formData.model.ticketsChangeMeter.oldUserCalNum !== null) {
        // 末次上报结算流量
        this.$set(that.formData.oldMeter, 'oldUserCalNum', that.formData.model.ticketsChangeMeter.oldUserCalNum)
      }

      if (that.formData.model.ticketsChangeMeter && that.formData.model.ticketsChangeMeter.userAccountNum !== null) {
        // 末次上报结算余额
        this.$set(that.formData.oldMeter, 'userAccountNum', that.formData.model.ticketsChangeMeter.userAccountNum)
      }
      if (that.formData.model.ticketsChangeMeter && that.formData.model.ticketsChangeMeter.meterUpTime !== null) {
        // 末次上报结算流量
        this.$set(that.formData.oldMeter, 'meterUpTime', that.formData.model.ticketsChangeMeter.meterUpTime)
      }
    },
    setOldMeterNum() {
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.whetherSettlementOldTable != null
      ) {
        // 是否旧表结算
        this.$set(
          this.formData.oldMeter,
          'whetherSettlementOldTable',
          this.formData.model.ticketsChangeMeter.whetherSettlementOldTable
        )
      } else {
        this.$set(this.formData.oldMeter, 'whetherSettlementOldTable', undefined)
      }
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.meterOldMachineSumFlow != null
      ) {
        // 旧表机械读数
        this.$set(
          this.formData.oldMeter,
          'meterOldMachineSumFlow',
          this.formData.model.ticketsChangeMeter.meterOldMachineSumFlow
        )
      } else {
        this.$set(this.formData.oldMeter, 'meterOldMachineSumFlow', '')
      }
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.meterUserAccountNumAfterChange != null
      ) {
        // 剩余金额
        this.$set(
          this.formData.oldMeter,
          'meterUserAccountNumAfterChange',
          this.formData.model.ticketsChangeMeter.meterUserAccountNumAfterChange
        )
      } else {
        this.$set(this.formData.oldMeter, 'meterUserAccountNumAfterChange', '')
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      const that = this
      // 复接 选择新表
      if (
        this.orderType == '复接' &&
        (this.formData?.newMeter?.newMeterId === '' || this.formData?.newMeter?.newMeterId === undefined)
      ) {
        this.$message.warning(this.$t('请选择新表数据'))
        return
      }
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          let message = ''

          let params = {}
          if (this.optionType == '处理') {
            httpurl += this.url.pass
            method = 'post'
            message = this.$t('处理成功')
            params = {
              dataId: that.formData.model.id,
              createTicketDTO: {
                repairPicture: that.formData.model.repairPicture,
                resolvedPictureFront: that.formData.model.resolvedPictureFront,
                resolvedPictureOpposite: that.formData.model.resolvedPictureOpposite,
                infoPicture: that.formData.model.infoPicture,

                ticketsChangeMeterReq: {
                  oldMeterBalances: that.formData.oldMeter.oldMeterBalances,
                  changingMeterReason: that.formData.model.changingMeterReason,
                  // changingMeterReasonDetail: that.formData.model.changingMeterReasonDetail,
                  meterTotalUse: '',
                  userMeterStartNum: that.formData.oldMeter.userMeterStartNum, // 旧表 计费起始读数
                  oldMeterStartNum: that.formData.oldMeter.oldMeterStartNum, // 旧表 计费起始读数
                  userAccountNum: that.formData.oldMeter.userAccountNum, // 旧表剩余金额
                  meterUpTime: that.formData.oldMeter.meterUpTime, // 旧表 末次上报日期
                  oldUserCalNum: that.formData.oldMeter.oldUserCalNum, // 旧表 末次结算流量
                  meterUserAccountNumAfterChange: that.formData.oldMeter.meterUserAccountNumAfterChange, // 剩余金额(元)
                  meterOldSumFlowAfterChange: that.formData.oldMeter.meterOldSumFlowAfterChange,
                  userKeyId: that.formData.model.userKeyId,
                  userId: that.formData.model.userId,
                  meterOldMachineSumFlow: that.formData.oldMeter.meterOldMachineSumFlow, // 旧表机械读数
                  whetherSettlementOldTable: that.formData.oldMeter.whetherSettlementOldTable, // 是否以旧表机械读数结算
                  oldMeterId: that.orderType == '复接'?'':that.formData.oldMeter.meterId, // 旧表ID
                  // oldPicture: that.formData.oldMeter.oldPicture, // 旧表照片
                  newMeterId: that.formData.newMeter.newMeterId, // 新表ID
                  // newPicture: that.model.newPicture, // 新表照片
                  meterStartNum: that.formData.newMeter.meterStartNum, // 新表开始计费读数
                  payOrNot: that.formData.model.payOrNot, // 是否收费
                  resolvedPictureOpposite: that.formData.model.resolvedPictureOpposite, // 支付凭证
                  resolvedPictureFront: that.formData.model.resolvedPictureFront, // 处理前照片
                  remark: that.formData.model.handleUserDescription, // 最后的备注
                  changingMeterReasonDetail: that.formData.model.ticketsChangeMeter?.changingMeterReasonDetail, // 处理描述
                },
                inspectionDetail: {
                  inspectionPicture: that.formData.model.inspectionDetail?.inspectionPicture,
                  inspectionDescription: that.formData.model.inspectionDetail?.inspectionDescription,
                },
              },
              comment: that.notInputRemark,
            }
          } else {
            // 审核
            httpurl += this.url.pass
            method = 'post'
            message = this.$t('处理成功')
            params = {
              dataId: that.formData.model.id,
              createTicketDTO: {
                ticketsChangeMeterReq: {
                  whetherSettlementOldTable: that.formData.oldMeter.whetherSettlementOldTable, // 是否以旧表机械读数结算
                  meterUserAccountNumAfterChange: that.formData.oldMeter.meterUserAccountNumAfterChange, // 剩余金额(元)
                  meterStartNum: that.formData.newMeter.meterStartNum, // 新表开始计费读数
                },
              },
              comment: that.notInputRemark,
            }
          }
          httpAction(httpurl, params, method)
            .then(res => {
              if (res.success) {
                that.$message.success(message)
                that.$emit('ok')
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
              that.confirmLoading = false
            })
            .finally(() => {
              that.confirmLoading = false
            })
        } else {
          this.$message.warning(this.$t('存在必填内容未填！'))
        }
      })
    },
    meterOldMachineSumFlowInput() {
      if (this.formData.oldMeter.whetherSettlementOldTable == 1) {
        console.log('计算剩余金额this.formData.oldMeter = ', this.formData.oldMeter)
        console.log('计算剩余金额this.formData.userInfo = ', this.formData.userInfo)
        console.log('计算剩余金额this.formData.model = ', this.formData.model)
        let params = {
          meterOldMachineSumFlow: this.formData.oldMeter.meterOldMachineSumFlow,
          userId: this.formData.userInfo.userId,
          meterIdOld: this.formData.userInfo.meterId ? this.formData.userInfo.meterId : this.formData.model.meterId,
          userKeyId: this.formData.userInfo.id,
        }
        httpAction(this.url.useOldMachineSumFlow, params, 'put').then(res => {
          if (res.success) {
            this.$set(this.formData.oldMeter, 'meterUserAccountNumAfterChange', res.result)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    // 选择新表
    selectNewMeter() {
      this.selectNewMeterModalVisible = true
    },
    handleMeterSelected(selectedMeter) {
      this.selectedMeter = selectedMeter
      // 新表编号
      this.formData.newMeter.newMeterId = selectedMeter.meterId
      // 新表口径
      this.formData.newMeter.newMtCaliber = selectedMeter.mtCaliber
      // 新表厂商 =
      this.formData.newMeter.newMtName = selectedMeter.mtName

      console.log('选中的表信息:', selectedMeter)
      // 这里可以处理选中的表信息，比如保存到父组件的数据中
    },
    getTagColor(value) {
      switch (value) {
        case 0:
          return 'red'
        case 1:
          return 'orange'
        case 2:
          return 'yellow'
        case 3:
          return 'blue'
        default:
          return 'default' // 你可以设置一个默认颜色
      }
    },
    whetherSettlementOldTableChange() {
      if (
        this.formData.oldMeter.whetherSettlementOldTable == 1 &&
        this.formData.oldMeter.meterOldMachineSumFlow != null
      ) {
        this.meterOldMachineSumFlowInput()
      } else {
        this.$set(this.formData.oldMeter, 'meterUserAccountNumAfterChange', undefined)
      }
      // 清除表单验证
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleCancel1() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
  },
}
</script>
